import BaseModelAPI from '../BaseModelAPI';

export default class Repair extends BaseModelAPI {
	static entity = 'repair';
	static entityName = 'repair';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.controlCardId = '';
			this.controlCard = {};
			this.controlCardNumber = '';
			this.caseQty = 0;
			this.qtyOk = 0;
			this.qtyNg = 0;
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.isScanned = '';
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}